export const DeliveryMatrixState = {
      name: "",
      start_date: "",
      end_date: "",
      delivery_matrix_zipcode_folders: [],
      delivery_matrix_address_types: [],
      delivery_matrix_days: [],
      delivery_matrix_items: [],
};
